import firebase from 'firebase/app'
import { get, isEmpty } from 'lodash'
import store from '../stores'
import roles from '../configs/roles'

export default async (to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.isPublic)
  const isPlatform = to.matched.some(record => record.meta.isPlatform)
  const preventRedirect = to.matched.some(record => record.meta.preventRedirect)
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  // Do we really want to refresh token each page?
  const token = firebase.auth().currentUser
    ? await firebase.auth().currentUser.getIdTokenResult(true)
    : null

  if (token && isEmpty(get(token, 'claims.tenant'))) {
    store.dispatch('logout')
  }

  const role = get(token, 'claims.role')

  const defaultRoute = role in roles
    ? roles[ role ].defaultRoute
    : { name: 'customers' } // fallback

  // check for requiredAuth
  if (requiresAuth) {
    // Check if NOT logged in
    if (!firebase.auth().currentUser) {
      // Go to login page
      next({
        path: '/platform/login',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }
  } else if (isPlatform && firebase.auth().currentUser) {
    preventRedirect
      ? next()
      : next(defaultRoute)
  } else if (isPublic && firebase.auth().currentUser) {
    // Using trying to access a public page but is logged in.
    next(defaultRoute)
  } else {
    next()
  }
};
